import { useQuery } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { PaymentRecord, PaymentRecordStatus } from '@/types'
import { Pagination } from '@/types/commons'

type ReadPaymentRecordsParams = {
  status?: PaymentRecordStatus
  deal_key: string
}

export async function readPaymentRecords({
  deal_key,
  ...params
}: ReadPaymentRecordsParams) {
  const response = await httpClient('accounting-dealer').get<
    Pagination<PaymentRecord>
  >(`/v3/deal/${deal_key}/payment-records`, {
    params,
  })

  return response.data
}

export function useReadPaymentRecords(params: ReadPaymentRecordsParams) {
  return useQuery({
    queryKey: ['payment-records', params],
    queryFn: () => readPaymentRecords(params),
  })
}
